import { useState } from 'react';
import Button from 'react-bootstrap/Button';
import Spinner from 'react-bootstrap/esm/Spinner';
import { useParams } from 'react-router-dom';
import {
  getRegistrations,
  toggleStartlist,
  updateRegistration,
} from '../../../api/Registrations';
import AddButton from '../../../components/Buttons/AddButton';
import RemoveButton from '../../../components/Buttons/RemoveButton';

function RegistrationBtnGroup({
  status,
  participantId,
  email,
  unRegistered,
  inStartlist,
  setRegistrations,
}) {
  const [updatingRegister, setUpdatingRegister] = useState(false);
  const [updatingStartlist, setUpdatingStartlist] = useState(false);
  const { id: competitionId } = useParams();

  async function fetchRegistrations() {
    const registrations = await getRegistrations(competitionId);

    if (registrations) {
      setRegistrations(registrations.registered);
      setUpdatingRegister(false);
      setUpdatingStartlist(false);
    }
  }

  const onUnregister = async (id, email, unRegistered) => {
    setUpdatingRegister(true);
    let inStartlist = false;

    let unregisterResult = await updateRegistration(
      competitionId,
      unRegistered,
      id ? [id] : [],
      email ? [email] : []
    );

    let removeStartlistStatus = await toggleStartlist(
      competitionId,
      id,
      email,
      inStartlist
    );

    if (unregisterResult.statusCode === 200 && removeStartlistStatus === 200) {
      setRegistrations(unregisterResult.registrations);
    }

    setUpdatingRegister(false);
  };

  const onAddToStart = async (id, email) => {
    setUpdatingStartlist(true);
    let inStartlist = true;
    let addStartlistStatus = await toggleStartlist(
      competitionId,
      id,
      email,
      inStartlist
    );

    if (addStartlistStatus === 200) {
      fetchRegistrations();
    } else {
      setUpdatingStartlist(false);
    }
  };

  const onRemoveFromStart = async (id, email) => {
    setUpdatingStartlist(true);
    let inStartlist = false;
    let removeStartlistStatus = await toggleStartlist(
      competitionId,
      id,
      email,
      inStartlist
    );

    if (removeStartlistStatus === 200) {
      fetchRegistrations();
    } else {
      setUpdatingStartlist(false);
    }
  };

  return (
    <div className='d-flex registration-btns'>
      { ( status === 'Kommande' ||  status === 'Pågående'  ) ? (
        <>
          {unRegistered ? (
            <>
              <Button
                variant='danger'
                className='d-flex align-items-center me-2 me-sm-3'
                onClick={() => onUnregister(participantId, email, unRegistered)}
                disabled={updatingRegister}
              >
                {updatingRegister ? (
                  <>
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                    <span className='visually-hidden'>Loading...</span>
                  </>
                ) : (
                  <>
                    <span className='material-symbols-outlined me-1'>
                      check
                    </span>
                  </>
                )}
                Avanmäl
              </Button>
              <AddButton
                variant='outline-primary'
                className='d-flex align-items-center'
                disabled={true}
                text='Startlista'
              />
            </>
          ) : !unRegistered && !inStartlist ? (
            <>
              <RemoveButton
                variant='outline-primary'
                className='d-flex align-items-center me-2 me-sm-3'
                onClick={() => onUnregister(participantId, email, unRegistered)}
                disabled={updatingRegister}
                loading={updatingRegister}
                text='Avanmäl'
              />
              <AddButton
                variant='outline-primary'
                className='d-flex align-items-center'
                onClick={() => onAddToStart(participantId, email)}
                loading={updatingStartlist}
                text='Startlista'
              />
            </>
          ) : (
            <>
              <RemoveButton
                variant='outline-primary'
                className='d-flex align-items-center me-2 me-sm-3'
                onClick={() => onUnregister(participantId, email, unRegistered)}
                disabled={updatingRegister}
                loading={updatingRegister}
                text='Avanmäl'
              />
              <Button
                variant='success'
                className='d-flex align-items-center'
                onClick={() => onRemoveFromStart(participantId, email)}
              >
                {updatingStartlist ? (
                  <>
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                    <span className='visually-hidden'>Loading...</span>
                  </>
                ) : (
                  <>
                    <span className='material-symbols-outlined me-1'>
                      check
                    </span>
                  </>
                )}
                Startlista
              </Button>
            </>
          )}
        </>
      ) : ( false ) ? (
        <>
          {unRegistered ? (
            <>
              <RemoveButton
                variant='danger'
                className='d-flex align-items-center me-2 me-sm-3'
                disabled={true}
                text='Avanmäl'
              />
              <AddButton
                variant='outline-primary'
                className='d-flex align-items-center'
                disabled={true}
                text='Startlista'
              />
            </>
          ) : !unRegistered && !inStartlist ? (
            <>
              <RemoveButton
                variant='outline-primary'
                className='d-flex align-items-center me-2 me-sm-3'
                disabled={true}
                text='Avanmäl'
              />
              <Button
                variant='outline-primary'
                className='d-flex align-items-center'
                onClick={() => onAddToStart(participantId, email)}
              >
                {updatingStartlist ? (
                  <>
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                    <span className='visually-hidden'>Loading...</span>
                  </>
                ) : (
                  <>
                    <span className='material-symbols-outlined me-1'>add</span>
                  </>
                )}
                Startlista
              </Button>
            </>
          ) : (
            <>
              <RemoveButton
                variant='outline-primary'
                className='d-flex align-items-center me-2 me-sm-3'
                disabled={true}
                text='Avanmäl'
              />
              <Button
                variant='success'
                className='d-flex align-items-center'
                onClick={() => onRemoveFromStart(participantId, email)}
              >
                {updatingStartlist ? (
                  <>
                    <Spinner
                      as='span'
                      animation='border'
                      size='sm'
                      role='status'
                      aria-hidden='true'
                      className='me-2'
                    />
                    <span className='visually-hidden'>Loading...</span>
                  </>
                ) : (
                  <>
                    <span className='material-symbols-outlined me-1'>
                      check
                    </span>
                  </>
                )}
                Startlista
              </Button>
            </>
          )}
        </>
      ) : (
        <>
          {!unRegistered ? (
            <RemoveButton
              variant='outline-primary'
              className='d-flex align-items-center me-2 me-sm-3'
              disabled={true}
              text='Avanmäl'
            />
          ) : (
            <Button
              variant='danger'
              className='d-flex align-items-center me-2 me-sm-3'
              disabled
            >
              <span className='material-symbols-outlined me-1'>check</span>
              Avanmäl
            </Button>
          )}
          {!inStartlist ? (
            <AddButton
              variant='outline-primary'
              className='d-flex align-items-center'
              disabled={true}
              text='Startlista'
            />
          ) : (
            <Button
              variant='success'
              className='d-flex align-items-center'
              disabled
            >
              <span className='material-symbols-outlined me-1'>check</span>
              Startlista
            </Button>
          )}
        </>
      )}
    </div>
  );
}

export default RegistrationBtnGroup;
